import { ListItem } from 'tamagui'
import { View, Text } from 'react-native'
import { formatDateToLongString } from '@/src/common/utils/date'
import type { useStatementsScreenProps } from '@/src/app/main/(tabs)/card/card-management/statements'
import * as Ids from '@/src/experiences/card-statements/e2e/ids'
import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { mesaColorNames, typography } from '@/src/common/theme'
import type { StatementItem } from '@/src/app/main/(tabs)/card/card-management/statements'

const NoStatements = () => (
  <View style={{ padding: 20, alignItems: 'center' }}>
    <Text style={{ fontSize: 12, color: '#888' }}>No statements available.</Text>
  </View>
)

type StatementsScreenRouterPush = Pick<ReturnType<typeof useStatementsScreenProps>, 'routerPush'>

function StatementListItem({
  item,
  bottomDivider,
  routerPush,
  index,
}: { item: StatementItem; index: number; bottomDivider: boolean } & StatementsScreenRouterPush) {
  const handlePress = () =>
    routerPush({
      pathname: '/main/card/card-management/statements/[id]',
      params: { id: item.statementId, statementDate: item.statementDate },
    })

  return (
    <ListItem
      onPress={handlePress}
      iconAfter={ChevronRight}
      pressTheme
      // @ts-expect-error tamagui typescript issue?
      backgroundColor="transparent"
      animation="medium"
      {...(bottomDivider && {
        borderBottomWidth: 1,
        borderBottomColor: mesaColorNames['global/grey/20 #E6E9EB'],
      })}
    >
      <Text
        style={[typography['label/sm-bold'], { color: mesaColorNames['global/grey/80 #2F3133'] }]}
      >
        {formatDateToLongString(new Date(item.statementDate))}
      </Text>
      <Text
        style={[
          typography['label/md-regular'],
          { color: mesaColorNames['Primary/Brand #1C1C1C'], flex: 1, textAlign: 'right' },
        ]}
        testID={index ? undefined : Ids.ViewStatement}
      >
        View
      </Text>
    </ListItem>
  )
}

export function StatementsSection({
  items,
  routerPush,
}: { items?: StatementItem[] } & StatementsScreenRouterPush) {
  return (
    <View style={{ overflow: 'hidden', paddingHorizontal: 16, flex: 1 }}>
      {items?.length ? (
        items.map((item, index) => (
          <StatementListItem
            key={item.statementId}
            item={item}
            bottomDivider={index !== items.length - 1}
            routerPush={routerPush}
            index={index}
          />
        ))
      ) : (
        <NoStatements />
      )}
    </View>
  )
}
